import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html'
})
export class ToastsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
